/**
 * Toast Store — manages in-app notification toast state.
 * Shows a banner when a notification arrives in foreground on a non-chat screen.
 */

import { create } from 'zustand';
import { Vibration, Platform } from 'react-native';

interface Toast {
  title: string;
  body: string;
  onPress?: () => void;
}

interface ToastState {
  toast: Toast | null;
  showToast: (title: string, body: string, onPress?: () => void) => void;
  dismissToast: () => void;
}

let _autoDismissTimer: ReturnType<typeof setTimeout> | null = null;

export const useToastStore = create<ToastState>()((set, get) => ({
  toast: null,

  showToast: (title: string, body: string, onPress?: () => void) => {
    if (_autoDismissTimer) clearTimeout(_autoDismissTimer);

    set({ toast: { title, body, onPress } });

    // Haptic feedback
    if (Platform.OS !== 'web') {
      Vibration.vibrate(200);
    }

    // Auto-dismiss after 4 seconds
    _autoDismissTimer = setTimeout(() => {
      set({ toast: null });
      _autoDismissTimer = null;
    }, 4000);
  },

  dismissToast: () => {
    if (_autoDismissTimer) {
      clearTimeout(_autoDismissTimer);
      _autoDismissTimer = null;
    }
    set({ toast: null });
  },
}));
